import type { JSX } from 'react';

import { FormError } from '@change-corgi/design-system-legacy/components/forms';
import { Text } from '@change-corgi/design-system-legacy/typography';

import { useMembershipModalState } from '../modalContext';

export function GeneralErrorMessage(): JSX.Element | null {
	const [{ formState }] = useMembershipModalState();
	if (formState?.status !== 'error') return null;

	return (
		<FormError
			data-testid="form-error"
			mb={16}
			sx={{
				mt: 16,
			}}
		>
			<Text as="span" color="sunrise.semantic.typography.error">
				{formState.error}
			</Text>
		</FormError>
	);
}
